// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Auth_wrapper__1-bxt"};